/* eslint-disable object-shorthand */
export const firstLetterUppercase = (e) => {
  e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1);
};

export const allLettersUppercase = (e) => {
  e.target.value = e.target.value.toUpperCase().trim();
};

export const allLettersLowercase = (e) => {
  e.target.value = e.target.value.toLowerCase().trim();
};

export const allLettersCapitalize = (e) => {
  e.target.value = e.target.value.toLowerCase().trim();
  e.target.value = e.target.value.replace(/\b\w/g, (l) => l.toUpperCase());
};

export const specialCharactersNotAllowed = (e) => {
  e.target.value = e.target.value.replace(/[^a-zA-Z0-9 ]/g, '');
};

export const onlyNumbersAllowed = (e) => {
  e.target.value = e.target.value.replace(/[^0-9]/g, '');
};

export function convertNumberToWords(number) {
  const words = [
    '',
    'One',
    'Two',
    'Three',
    'Four',
    'Five',
    'Six',
    'Seven',
    'Eight',
    'Nine',
    'Ten',
    'Eleven',
    'Twelve',
    'Thirteen',
    'Fourteen',
    'Fifteen',
    'Sixteen',
    'Seventeen',
    'Eighteen',
    'Nineteen',
  ];
  const tens = [
    '',
    '',
    'Twenty',
    'Thirty',
    'Forty',
    'Fifty',
    'Sixty',
    'Seventy',
    'Eighty',
    'Ninety',
  ];

  function convertThreeDigit(num) {
    if (num === 0) {
      return '';
    }
    if (num < 20) {
      return `${words[num]}`;
    }
    if (num < 100) {
      return `${tens[Math.floor(num / 10)]} ${convertThreeDigit(num % 10)}`;
    }
    return `${words[Math.floor(num / 100)]} Hundred ${convertThreeDigit(num % 100)}`;
  }

  if (number === 0) {
    return 'Zero';
  }

  const crore = Math.floor(number / 10000000);
  const lakh = Math.floor((number % 10000000) / 100000);
  const thousands = Math.floor((number % 100000) / 1000);
  const remainder = number % 1000;

  let result = '';

  if (crore > 0) {
    result += `${convertThreeDigit(crore)} Crore `;
  }

  if (lakh > 0) {
    result += `${convertThreeDigit(lakh)} Lakh `;
  }

  if (thousands > 0) {
    result += `${convertThreeDigit(thousands)} Thousand `;
  }

  if (remainder > 0) {
    result += convertThreeDigit(remainder);
  }

  return result.trim();
}

export const formatCurrency = (number) =>
  number > 0
    ? number.toLocaleString('en-IN', {
        style: 'decimal',
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      })
    : number;

export function formatModernCount(num) {
  const number = Number(num) || 0;
  let finalCount = 0;
  if (number >= 1e7) {
    finalCount = number / 1e7;
    return `${finalCount % 1 ? finalCount.toFixed(2) : finalCount} Cr`;
  }
  if (number >= 1e5) {
    finalCount = number / 1e5;
    return `${finalCount % 1 ? finalCount.toFixed(2) : finalCount} L`;
  }
  if (number >= 1e3) {
    finalCount = number / 1e3;
    return `${finalCount % 1 ? finalCount.toFixed(2) : finalCount} K`;
  }
  return number;
}

export const totalPercentValue = (value = 0, total = 0) => {
  const subValue = Number(value);
  const totalValue = Number(total);
  if (subValue > 0 && totalValue > 0) return (subValue / totalValue) * 100;
  return 0;
};

export const filterNavConfigByDesignation = (navConfig = [], designationData = null) => {
  if (designationData) {
    const finalData = [];
    navConfig?.forEach((list) => {
      const { subheader = '', items = [] } = list;
      // map of items containing modules and sub mondules
      if (items?.length > 0) {
        const subListData = [];
        items?.forEach((subList) => {
          // cond. 1 If module has sub module
          if (subList.children) {
            // check for both module and sub module rights assigned keys
            const superSubList = subList?.children.filter(
              (superSub) =>
                designationData[subList.assignedRightsKey][superSub.assignedRightsKey] === true
            );
            if (superSubList?.length > 0) {
              // add module if any sub modules were assigned rights
              subListData.push({
                ...subList,
                children: superSubList,
              });
            }
          }
          // cond. 2 If module is project has any of the one right among project rights
          else if (
            subList.assignedRightsKey === 'projectManagementRights' &&
            Object.values(designationData[subList.assignedRightsKey]).some(
              (value) => value === true
            )
          ) {
            subListData.push(subList);
          }
          // cond. 3 If module doesn't have children and if rights were assigned
          else if (designationData[subList.assignedRightsKey]) subListData.push(subList);
        });
        finalData.push({
          subheader: subListData.length > 0 ? subheader : '',
          items: subListData,
        });
      }
    });
    return finalData;
  }
  return navConfig;
};
export const filterNavConfigByAuthority = (navConfig = [], designationDataArray = []) => {
  if (designationDataArray && designationDataArray.length > 0) {
    // Initialize a set to store unique subheaders and items
    const uniqueItems = new Set();
    
    // Initialize an array to store the final filtered navigation configuration
    let finalData = [];
    
    // Iterate over each designation data
    designationDataArray.forEach(designationData => {
      const filteredNavConfig = [];

      navConfig.forEach((list) => {
        const { subheader = '', items = [] } = list;
        
        if (items && items.length > 0) {
          const subListData = [];

          items.forEach((subList) => {
            if (subList.children) {
              const superSubList = subList.children.filter(
                (superSub) =>
                  designationData[subList.assignedRightsKey][superSub.assignedRightsKey] === true
              );
              if (superSubList.length > 0) {
                subListData.push({
                  ...subList,
                  children: superSubList,
                });
              }
            } else if (
              subList.assignedRightsKey === 'projectManagementRights' &&
              Object.values(designationData[subList.assignedRightsKey]).some(
                (value) => value === true
              )
            ) {
              subListData.push(subList);
            } else if (designationData[subList.assignedRightsKey]) {
              subListData.push(subList);
            }
          });

          if (subListData.length > 0) {
            const subheaderKey = JSON.stringify(subheader);
            if (!uniqueItems.has(subheaderKey)) {
              filteredNavConfig.push({
                subheader: subheader,
                items: subListData,
              });
              uniqueItems.add(subheaderKey);
            }
          }
        }
      });

      // Concatenate the filtered navigation configuration for the current designation data
      finalData = finalData.concat(filteredNavConfig);
    });
    return finalData;
  }

  return navConfig;
};

// export const filterNavConfigByAuthority = (navConfig = [], designationDataArray = []) => {
//   console.log("navConfig=", navConfig, designationDataArray);
//   if (designationDataArray && designationDataArray.length > 0) {
//     // Initialize an array to store the final filtered navigation configuration
//     let finalData = [];
    
//     // Iterate over each designation data
//     designationDataArray.forEach(designationData => {
//       const filteredNavConfig = [];

//       navConfig.forEach((list) => {
//         const { subheader = '', items = [] } = list;
        
//         if (items && items.length > 0) {
//           const subListData = [];

//           items.forEach((subList) => {
//             if (subList.children) {
//               const superSubList = subList.children.filter(
//                 (superSub) =>
//                   designationData[subList.assignedRightsKey][superSub.assignedRightsKey] === true
//               );
//               if (superSubList.length > 0) {
//                 subListData.push({
//                   ...subList,
//                   children: superSubList,
//                 });
//               }
//             } else if (
//               subList.assignedRightsKey === 'projectManagementRights' &&
//               Object.values(designationData[subList.assignedRightsKey]).some(
//                 (value) => value === true
//               )
//             ) {
//               subListData.push(subList);
//             } else if (designationData[subList.assignedRightsKey]) {
//               subListData.push(subList);
//             }
//           });

//           if (subListData.length > 0) {
//             filteredNavConfig.push({
//               subheader: subheader,
//               items: subListData,
//             });
//           }
//         }
//       });

//       // Concatenate the filtered navigation configuration for the current designation data
//       finalData = finalData.concat(filteredNavConfig);
//     });
//     console.log("navConfiggg=", finalData);
//     return finalData;
//   }

//    return navConfig;
// };


